/** This file and the solution is a temporary one
 * to support legacy collections retirement. This should be coming from APIs
 * and story HMEX-1107 is being worked on to implement that. ETA - Q1 2023.
 *  */
const homeDepot = {
  label: 'Home',
  url: 'https://www.homedepot.com/'
};
const defaultBreadCrumb = [{
  label: 'Home Decor',
  url: 'https://www.homedepot.com/b/Home-Decor/N-5yc1vZas6p'
}];

const bath = {
  label: 'Bath',
  url: 'https://www.homedepot.com/b/Bath/N-5yc1vZbzb3'
};
const decor = {
  label: 'Shop By Room',
  url: 'https://www.homedepot.com/room'
};
const furniture = {
  label: 'Furniture',
  url: 'https://www.homedepot.com/b/Furniture/N-5yc1vZc7pc'
};
const kitchen = {
  label: 'Kitchen',
  url: 'https://www.homedepot.com/b/Kitchen/N-5yc1vZar4i'
};
const kitchenSinks = {
  label: 'Kitchen Sinks',
  url: 'https://www.homedepot.com/b/Kitchen-Kitchen-Sinks/N-5yc1vZarsa'
};
const kitchenCollections = {
  label: 'Kitchen Collections',
  url: 'https://www.homedepot.com/b/Kitchen-Kitchen-Cabinets/N-5yc1vZas87'
};
const lighting = {
  label: 'Lighting',
  url: 'https://www.homedepot.com/b/Lighting/N-5yc1vZbvn5'
};
const outdoors = {
  label: 'Outdoors',
  url: 'https://www.homedepot.com/b/Outdoors/N-5yc1vZbx82'
};
const breadCrumbUrls = {
  bath: [
    bath
  ],
  'bathroom-vanities': [
    bath,
    {
      label: 'Bathroom Vanities',
      url: 'https://www.homedepot.com/b/Bath-Bathroom-Vanities/N-5yc1vZcfv3',
    }
  ],
  'cabinets-cabinet-hardware': [
    kitchen,
    kitchenCollections
  ],
  decor: [
    decor
  ],
  'food-fertilizer': [
    outdoors,
    {
      label: 'Garden Center',
      url: 'https://www.homedepot.com/b/Outdoors-Garden-Center/N-5yc1vZbx6k',
    }
  ],
  furniture: [
    furniture
  ],
  'home-decor': [{
    label: 'Home Decor',
    url: 'https://www.homedepot.com/b/Home-Decor/N-5yc1vZas6p'
  }],
  kitchen: [
    kitchen
  ],
  'kitchen-cabinets': [
    kitchen,
    kitchenCollections
  ],
  'kitchen-kitchen-cabinets': [
    kitchen,
    kitchenCollections
  ],
  'kitchen-countertops': [
    kitchen,
    {
      label: 'Countertops',
      url: 'https://www.homedepot.com/b/Kitchen-Countertops/N-5yc1vZbmf2'
    }
  ],
  'kitchen-sinks': [
    kitchen,
    kitchenSinks
  ],
  'kitchen-kitchen-sinks': [
    kitchen,
    kitchenSinks
  ],
  lighting: [
    lighting
  ],
  'living-room-furniture': [
    furniture,
    {
      label: 'Living Room Furniture',
      url: 'https://www.homedepot.com/b/Furniture-Living-Room-Furniture/N-5yc1vZc7p3'
    }
  ],
  outdoors: [
    outdoors
  ],
  'outdoor-power-equipment': [
    outdoors,
    {
      label: 'Outdoor Power Equipment',
      url: ' https://www.homedepot.com/b/Outdoors-Outdoor-Power-Equipment/N-5yc1vZbx5c'
    }
  ],
  paint: [{
    label: 'Paint',
    url: 'https://www.homedepot.com/b/Paint/N-5yc1vZar2d'
  }],
  'patio-furniture': [
    outdoors,
    {
      label: 'Patio Furniture',
      url: ' https://www.homedepot.com/b/Outdoors-Patio-Furniture/N-5yc1vZbx4o'
    }
  ],
  'storage-organization': [{
    label: 'Storage & Organization',
    url: 'https://www.homedepot.com/b/Storage-Organization/N-5yc1vZas7e'
  }]

};

const getParentCategoryNameFromUrl = (url) => {
  const result = url.match(new RegExp('/collection/(.*)/', 'i'));
  return (result && result.length > 1) ? result[1] : '';
};

export const getVendorCollectionBreadCrumbs = (path = '/collection/home-decor/') => {
  // path = '/collection/storage-organization/'; //Test Locally
  let breadCrumbs = [
    homeDepot
  ];
  const breadCrumbKey = getParentCategoryNameFromUrl(path || '');
  let breadCrumbsList = breadCrumbUrls[breadCrumbKey ? breadCrumbKey.toLowerCase() : ''];
  breadCrumbsList = breadCrumbsList || defaultBreadCrumb;
  breadCrumbsList.forEach((eachCrumb) => {
    breadCrumbs.push(eachCrumb);
  });
  return breadCrumbs;
};